import { Either, Right } from 'fp-ts/lib/Either'

export function allRight<L, R>(xs: Array<Either<L, R>>): xs is Array<Right<L, R>> {
  return xs.every(x => x.isRight())
}
